module.exports = __webpack_public_path__ + "static/media/Add_Button_Positive_Inner_Fruit.170468e7.svg";